module.exports = __webpack_public_path__ + "img/NorseCapTechHammerOfThor.51f2c345.webp";